import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import styles from './SearchResultInfo.styles.m.css';

export const SearchResultInfo: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.text}>{t('main_search_label')}</div>
    </div>
  );
};
